import { User, PanelRightClose } from 'lucide-react';
import { ShopifyCustomerCard } from './ShopifyCustomerCard';

interface CustomerContextPanelProps {
  customerEmail: string;
  customerName?: string;
  onCollapse: () => void;
}

export function CustomerContextPanel({
  customerEmail,
  customerName,
  onCollapse,
}: CustomerContextPanelProps) {
  return (
    <div className="w-80 flex-shrink-0 border-l border-gray-200/60 bg-gray-50/30 flex flex-col h-full overflow-hidden">
      {/* Panel Header */}
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100 bg-white flex-shrink-0">
        <div className="flex items-center gap-2">
          <User size={14} className="text-gray-400" />
          <span className="text-xs font-semibold text-gray-500 uppercase tracking-wide">Customer</span>
        </div>
        <button
          onClick={onCollapse}
          className="p-1 hover:bg-gray-100 rounded-lg transition-colors"
          title="Close panel"
        >
          <PanelRightClose size={16} className="text-gray-400" />
        </button>
      </div>

      {/* Scrollable Content */}
      <div className="flex-1 overflow-y-auto">
        <ShopifyCustomerCard email={customerEmail} customerName={customerName} />
      </div>
    </div>
  );
}
